
import React, { useMemo } from 'react';
import { Viewer, Worker, ScrollMode } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

const PDFViewer = ({ base64Data, width = '100%', height = '100%' }) => {
    // Prepare the PDF file as a Blob URL
    const pdfUrl = useMemo(() => {
        if (!base64Data) return null;
        let cleanBase64 = base64Data;
        if (base64Data.startsWith('data:')) {
            const commaIndex = base64Data.indexOf(',');
            if (commaIndex !== -1) {
                cleanBase64 = base64Data.substring(commaIndex + 1);
            }
        }
        try {
            const binaryString = atob(cleanBase64);
            const bytes = new Uint8Array(binaryString.length);
            for (let i = 0; i < binaryString.length; i++) {
                bytes[i] = binaryString.charCodeAt(i);
            }
            const blob = new Blob([bytes], { type: 'application/pdf' });
            return URL.createObjectURL(blob);
        } catch {
            return null;
        }
    }, [base64Data]);

    const defaultLayoutPluginInstance = defaultLayoutPlugin();

    if (!base64Data) {
        return <div style={{ width, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>No PDF data</div>;
    }

    if (!pdfUrl) {
        return <div style={{ width, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'red' }}>Invalid PDF data</div>;
    }

    return (
        <div className="pdf-inline-viewer" style={{ width, height }}>
            <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                <Viewer
                    fileUrl={pdfUrl}
                    defaultScale={1.0}
                    scrollMode={ScrollMode.Vertical}
                    plugins={[defaultLayoutPluginInstance]}
                />
            </Worker>
        </div>
    );
};

export default PDFViewer;
